'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
var defaults = {
  portalId: null,
  name: null,
  createdByUserId: null,
  createdAt: null,
  ordering: null
};

var ActivityType = /*#__PURE__*/function (_Record) {
  _inherits(ActivityType, _Record);

  function ActivityType() {
    _classCallCheck(this, ActivityType);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActivityType).apply(this, arguments));
  }

  _createClass(ActivityType, null, [{
    key: "from",
    value: function from(json) {
      return new ActivityType(json);
    }
  }]);

  return ActivityType;
}(Record(defaults));

export { ActivityType as default };